module.exports = __webpack_public_path__ + "media/npc_dota_hero_shadow_demon.a6f65b64.webm";